import beginnerBarIcon from "../assets/images/course/beginerBar.svg";
import intermediateBarIcon from "../assets/images/course/intermediatebar.svg";
import advanceBarIcon from "../assets/images/course/advancebar.svg";
import defaultLogo from "../assets/images/company-logo.png";
import devLogo from "../assets/images/logo-one.png";
import invensisLogo from "../assets/images/invensis_logo.png";
import vijnataLogo from "../assets/images/vijnata_logo_1.png";
import masterjiLogo from "../assets/images/masterji_logo.png";

export const ROLES = {
  ORGANIZATION_COORDINATOR: "organizationCoordinator",
  PROGRAM_COORDINATOR: "programCoordinator",
  COURSE_PARTICIPANT: "courseParticipant",
  COURSE_MANAGER: "courseManager",
  PLATFORM_COORDINATOR: "platformCoordinator",
};

export const roleIdWithName = [
  {
    id: "organizationCoordinator",
    name: "Organization Coordinator",
  },
  {
    id: "programCoordinator",
    name: "Program Coordinator",
  },
  {
    id: "courseParticipant",
    name: "Course Participant",
  },
  {
    id: "courseManager",
    name: "Course Manager",
  },
  {
    id: "platformCoordinator",
    name: "Platform Coordinator",
  },
];

// Menu items with conditional rendering rules
export const menuItems = [
  {
    path: "/about-organization",
    title: "Organization",
    roles: [ROLES.ORGANIZATION_COORDINATOR],
    hasDropdown: false,
  },
  {
    path: "/organization-details",
    title: "Organizations",
    roles: [ROLES.PLATFORM_COORDINATOR],
    hasDropdown: false,
  },
  {
    path: "/content-generation-dashboard",
    title: "Content Generation",
    hasDropdown: false,
    roles: [
      ROLES.PLATFORM_COORDINATOR,
      ROLES.ORGANIZATION_COORDINATOR,
      ROLES.PROGRAM_COORDINATOR,
      ROLES.COURSE_MANAGER,
    ],
    featureRequired: "Personalised Content Generation",
  },
  {
    path: "/courses",
    title: "Courses",
    hasDropdown: false,
    roles: [
      ROLES.PLATFORM_COORDINATOR,
      ROLES.ORGANIZATION_COORDINATOR,
      ROLES.PROGRAM_COORDINATOR,
      ROLES.COURSE_MANAGER,
    ],
    // featureRequired: "Course Viewing",
  },
  {
    path: "/user-groups",
    title: "Training Programs",
    roles: [ROLES.ORGANIZATION_COORDINATOR, ROLES.PROGRAM_COORDINATOR],
    featureRequired: "Program Management",
    hasDropdown: false,
  },
  {
    path: "/live-class",
    title: "Live Classes",
    roles: [
      ROLES.PLATFORM_COORDINATOR,
      ROLES.ORGANIZATION_COORDINATOR,
      ROLES.PROGRAM_COORDINATOR,
      ROLES.COURSE_MANAGER,
      ROLES.COURSE_PARTICIPANT,
    ],
    featureRequired: "Live Class",
    hasDropdown: false,
  },
  {
    path: "/calendar",
    title: "Calendar",
    roles: [
      ROLES.PLATFORM_COORDINATOR,
      ROLES.ORGANIZATION_COORDINATOR,
      ROLES.PROGRAM_COORDINATOR,
      ROLES.COURSE_MANAGER,
      ROLES.COURSE_PARTICIPANT,
    ],
    featureRequired: "ERP Features",
  },
  {
    path: "/timetable",
    title: "Timetable",
    roles: [
      ROLES.PLATFORM_COORDINATOR,
      ROLES.ORGANIZATION_COORDINATOR,
      ROLES.PROGRAM_COORDINATOR,
      ROLES.COURSE_MANAGER,
      ROLES.COURSE_PARTICIPANT,
    ],
    featureRequired: "ERP Features",
  },
  {
    path: "/attendance",
    title: "Attendance",
    roles: [ROLES.ORGANIZATION_COORDINATOR, ROLES.PROGRAM_COORDINATOR],
    featureRequired: "ERP Features",
  },
  {
    path: "/erp",
    title: "ERP",
    hasDropdown: true,
    roles: [ROLES.ORGANIZATION_COORDINATOR, ROLES.PLATFORM_COORDINATOR],
    featureRequired: "ERP Features",
    dropdownOptions: [
      {
        title: "Academic Years",
        path: "/academic-years",
        roles: [ROLES.ORGANIZATION_COORDINATOR, ROLES.PLATFORM_COORDINATOR],
        featureRequired: "ERP Features",
      },
      {
        title: "Sections",
        path: "/sections",
        roles: [ROLES.ORGANIZATION_COORDINATOR, ROLES.PLATFORM_COORDINATOR],
        featureRequired: "ERP Features",
      },
      {
        title: "Event Types",
        path: "/event-types",
        roles: [ROLES.ORGANIZATION_COORDINATOR, ROLES.PLATFORM_COORDINATOR],
        featureRequired: "ERP Features",
      },
      {
        title: "Manage Timetable",
        path: "/manage-timetable",
        roles: [ROLES.ORGANIZATION_COORDINATOR, ROLES.PLATFORM_COORDINATOR],
        featureRequired: "ERP Features",
      },
      {
        title: "Attendance History",
        path: "/attendance-history",
        roles: [ROLES.ORGANIZATION_COORDINATOR],
        featureRequired: "ERP Features",
      },
    ],
  },
];

export const roleFeatureMapping = {
  programCoordinator: [
    "Personalised Content Generation",
    "Progress Tracking",
    "Quiz/Assignment Generation",
    "Code Sandbox",
    "Course Upload",
    "Program Management",
    "Live Class",
    "ERP Features",
  ],
  courseParticipant: [
    "Progress Tracking",
    "Live Class",
    "ERP Features"],
  courseManager: [
    "Personalised Content Generation",
    "Quiz/Assignment Generation",
    "Code Sandbox",
    "Course Upload",
    "Live Class",
    "ERP Features",
  ],
  organizationCoordinator: [
    "Course Upload",
    "Program Management",
    "Progress Tracking",
    "Analytics",
    "Personalised Content Generation",
    "Course Viewing",
    "Live Class",
    "Code Solution Generator",
    "Subjective Quiz",
    "ERP Features",
  ],
  platformCoordinator: [
    "Course Upload",
    "Program Management",
    "Progress Tracking",
    "Analytics",
    "Quiz/Assignment Generation",
    "Personalised Content Generation",
    "Code Sandbox",
    "Vijnata Courses Basic",
    "Vijnata Courses Intermediate",
    "Vijnata Courses Advanced",
    "Course Viewing",
    "Live Class",
    "Code Solution Generator",
    "Subjective Quiz",
    "ERP Features",
  ],
};

export const questionDifficultyLevels = [
  {
    value: "easy",
    label: "Easy",
  },
  {
    value: "medium",
    label: "Medium",
  },
  {
    value: "hard",
    label: "Hard",
  },
];

export const questionType = [
  {
    value: "mcq",
    label: "MCQ",
  },
  // {
  //   value: "fill_in_the_blanks",
  //   label: "FILL IN THE BLANKS",
  // },
  {
    value: "true_false",
    label: "TRUE/FALSE",
  },
];
export const questionFormats = [
  {
    value: "objective",
    label: "Objective",
  },
  {
    value: "subjective",
    label: "Subjective",
  },
];

export const courseTypes = {
  UPCOMING: "UPCOMING",
  ONGOING: "IN PROGRESS",
  COMPLETED: "COMPLETED",
};

export const courseLevelStyle = {
  beginner: {
    color: "#007C3B",
    backgroundColor: "#007C3B14",
    icon: beginnerBarIcon,
  },
  intermediate: {
    color: "#CC810F",
    backgroundColor: "#BF921F0F",
    icon: intermediateBarIcon,
  },
  advance: {
    color: "#E6165C",
    backgroundColor: "#E6165C0F",
    icon: advanceBarIcon,
  },
};

export const quizPalletes = [
  {
    title: "Answered",
    color: "#0BBC79",
  },
  {
    title: "Unanswered",
    color: "#BCB9B9",
  },
  // {
  //   title: "Not Visited",
  //   color: "#DD2025",
  // },
];

export const programmingLanguages = [
  {
    title: "Python",
    versions: ["3.10.0", "3.12.0"],
  },
  {
    title: "c++",
    versions: ["10.2.0"],
  },
  {
    title: "Java",
    versions: ["15.0.2"],
  },
  {
    title: "c#",
    versions: ["5.0.201"],
  },
  ,
  {
    title: "c",
    versions: ["10.2.0"],
  },
  {
    title: "MySQL",
    versions: ["3.36.0"],
  },
];

export const progressColor = {
  high: "#288F58",

  mid: "#EC9C15",

  low: "#BC400A",
};

export const courseCategoryOptions = [
  { value: "", label: "Choose Category" },
  { value: "courseMedia", label: "Course Media" },
  { value: "quiz", label: "Quiz" },
  { value: "assignment", label: "Assignment" },
  // { value: "readingMaterial", label: "Reading Material" },
  // { value: "capstoneProject", label: "Capstone project" },
];

export const courseSubCategoryOptions = [
  { categoryName: "", value: "", label: "Choose Category" },
  // { categoryName: "courseMedia", value: "audio", label: "Audio" },
  { categoryName: "courseMedia", value: "video", label: "Video" },
  // { categoryName: "courseMedia", value: "image", label: "Image" },
  {
    categoryName: "courseMedia",
    value: "supplementaryMaterial",
    label: "Document",
  },
  { categoryName: "quiz", value: "quiz", label: "Manual Mode" },
  { categoryName: "quiz", value: "quizSubjective", label: "Subjective Quiz" },
  { categoryName: "quiz", value: "quizGeneration", label: "Q&A Generator" },
  { categoryName: "quiz", value: "quizBulkUpload", label: "Bulk Upload" },
  { categoryName: "assignment", value: "codeSandbox", label: "Code Sandbox" },
];

export const liveKitServerUrl =
  "wss://vijnata-live-class-7fpjudu1.livekit.cloud";
export const userManagementOptions = ["Azure", "AWS", "Google", "Self"];

export const genAIModelOptions = ["ChatGPT", "Ollama", "DeepSeek"];


export const subDomainLogoMapping = [
  {
    name: "dev",
    logo: vijnataLogo,
  },
  {
    name: "demo",
    logo: vijnataLogo,
  },
  {
    name: "invensis",
    logo: invensisLogo,
  },
  {
    name: "lms",
    logo: vijnataLogo,
  },
  {
    name: "masterji",
    logo: masterjiLogo,
  },
];